import React from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import BaseAutoSuggestComponent from './BaseAutoSuggestComponent';
import authUtil from 'util/auth';
const getFilterProperty = (filterItem) => (
   Array.isArray(filterItem)
      ? filterItem
      : filterItem.id
);

const reshapeSelectedSuggestion = ({ text, ...rest }) => {
   return ({ name: text, ...rest });
};


const checkAccess = (access, userRoleListEmployer) => {
   return !access
      ? true // if access is not define then there is no restriction.
      : authUtil.hasAuthAccessBase({
         access,
         userRoleListEmployer,
      });
};


function renderAutoSuggestWithOptions(
   dataObservable$,
   dataSubject$,
   renderSuggestion,
   getSuggestionValue,
   reFormatSelection,
   access,
) {
   return connect((state) => {
      return ({
         isLoggedIn: state.authReducer.isLoggedIn,
         loggedInUser: state.authReducer.loggedInUser,
      });
   })(
      class extends React.Component {
         constructor(props) {
            super(props);
            this.state = {
               value: props.selected.name,
               isLoading: false,
               suggestions: [],
               selectedSuggestion: props.selected ? props.selected : {
                  id: null,
                  name: '',
               },
               hasAccess: checkAccess(access, props.loggedInUser?.roles),
            };
            this.stopLoading = this.stopLoading.bind(this);
            this.onKeyDown = this.onKeyDown.bind(this);
         }

         componentDidMount() {
            this.subscription = dataObservable$.subscribe(
               (data) => {
                  this.setState({
                     isLoading: false,
                     suggestions: data,
                  });
               },
            );
         }

         static getDerivedStateFromProps(nextProps, prevState) {
            const hasAccess = checkAccess(access, nextProps.loggedInUser?.roles);

            if (hasAccess !== prevState.hasAccess) {
               return {
                  hasAccess,
               };
            }

            return null;
         }

         componentWillUnmount() {
            this.subscription.unsubscribe();
         }

         onChange = (event, { newValue }) => {
            this.setState({
               value: newValue,
               selectedSuggestion: null,
            }, () => {
               this.onSelection();
            });
         };

         onSelection() {
            if (this.props.onSelection) {
               let obj;
               if (reFormatSelection) {
                  if (this.state.selectedSuggestion) {
                     obj = reFormatSelection(this.state.selectedSuggestion);
                  } else {
                     obj = reFormatSelection(this.state.value);
                  }
               } else {
                  obj = {};
                  obj.name = this.state.value;
                  if (this.state.selectedSuggestion) {
                     obj = reshapeSelectedSuggestion(this.state.selectedSuggestion);
                  }
               }
               this.props.onSelection(obj);
            }
         }

         onSuggestionSelected = (suggestion) => {
            this.setState({
               selectedSuggestion: suggestion
            }, () => {
               this.onSelection();

               if (this.props.onSuggestionSelected) {
                  this.props.onSuggestionSelected(reshapeSelectedSuggestion(suggestion));
               }
            });

            if (this.props.onBlur) {
               this.props.onBlur();
            }
         };

         loadSuggestions(value) {
            const queryObj = {};
            queryObj.keyword = value;
            queryObj.params = {};

            const { filterOrganization, filterCompany, filterHiringCompany } = this.props;

            if (filterOrganization) {
               queryObj.params.organizationId = getFilterProperty(filterOrganization);
            }

            if (filterCompany) {
               queryObj.params.companyId = getFilterProperty(filterCompany);
            }

            if (filterHiringCompany) {
               queryObj.params.hiringCompanyId = getFilterProperty(filterHiringCompany);
            }

            this.setState({
               isLoading: true,
            }, () => {
               dataSubject$.next(queryObj);
            });
         }

         onSuggestionsFetchRequested = ({ value }) => {
            this.loadSuggestions(value);
         };

         stopLoading() {
            this.setState({
               isLoading: false,
            });

            if (this.props.onBlur) {
               this.props.onBlur();
            }
         }

         onSuggestionsClearRequested = () => {
            this.setState({
               suggestions: [],
            });
         };

         onKeyDown(event) {
            try {
               if (event.key === 'Enter') {
                  event.target.blur();
                  event.preventDefault();
               }
            } catch (e) {
               console.error(e);
            }
         }

         render() {
            const { suggestions, isLoading } = this.state;
            const { className, selected, placeholder } = this.props;
            let value = selected && selected.name ? selected.name : '';
            if (!lodash.isUndefined(this.props.value) && lodash.isString(this.props.value)) {
               value = this.props.value;
            } else if (lodash.isObject(this.props.value) && lodash.isString(this.props.value.city)) {
               value = this.props.value.city;
            }
            // Autosuggest will pass through all these props to the input.
            const inputProps = {
               placeholder: placeholder || 'Search',
               value,
               onChange: this.onChange,
               isLoading,
               onBlur: this.stopLoading,
               disabled: this.props.disabled || !(this.state.hasAccess) || false,
               className: className || '',
               onKeyDown: this.onKeyDown,
            };

            return (
               <>
                  <BaseAutoSuggestComponent
                     id={ this.props.id || 'AutoSuggest' }
                     suggestions={ suggestions }
                     onSuggestionsFetchRequested={ this.onSuggestionsFetchRequested }
                     onSuggestionsClearRequested={ this.onSuggestionsClearRequested }
                     onSuggestionSelected={ this.onSuggestionSelected }
                     inputProps={ inputProps }
                     { ...(renderSuggestion ? { renderSuggestion } : {}) }
                     { ...(getSuggestionValue ? { getSuggestionValue } : {}) }
                  />
                  {
                     !this.state.hasAccess && (
                        <span className='text-danger'>
                           <b>Requires employer admin access rights.</b>
                        </span>
                     )
                  }
               </>
            );
         }
      },
   );
}

export default renderAutoSuggestWithOptions;
